import jwtDecode from "jwt-decode";
import { checkSession } from "./auth.js";
const audience = "fake_https://api.local:3080/";
let tokenCache = {};
const createTokenKey = (audience2, scopes) => `${audience2}::${scopes}`;
const cacheToken = (accessToken) => {
  const token = jwtDecode(accessToken);
  const tokenKey = createTokenKey(
    Array.isArray(token.aud) ? token.aud.join(" ") : token.aud,
    token.scope
  );
  const timeoutToken = cacheTokenWithLifetime(tokenKey, token.exp);
  tokenCache[tokenKey] = {
    token: accessToken,
    clearTimeoutToken: timeoutToken
  };
};
const clearTokenCache = () => {
  tokenCache = {};
};
const cacheTokenWithLifetime = (tokenKey, expiresIn) => {
  return window.setTimeout(
    () => {
      if (tokenKey in tokenCache) {
        delete tokenCache[tokenKey];
      }
    },
    expiresIn * 1e3 - 5e3
  );
};
const getToken = async (...scopes) => {
  const scopeString = scopes.join(" ");
  const tokenKey = createTokenKey(audience, scopeString);
  const cachedTokenEntry = tokenCache[tokenKey];
  if (cachedTokenEntry && cachedTokenEntry.token) {
    return cachedTokenEntry.token;
  }
  const authResult = await checkSession({
    audience,
    scope: scopeString,
    responseType: "token"
  });
  if (!authResult.accessToken) {
    throw new Error(`Did not receive accessToken from Auth0`);
  }
  if (!authResult.expiresIn) {
    throw new Error(`Did not receive accessToken expiry, received '${authResult.expiresIn}'`);
  }
  cacheToken(authResult.accessToken);
  return authResult.accessToken;
};
export {
  cacheToken,
  clearTokenCache,
  getToken
};
//# sourceMappingURL=token-service.js.map
